import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { InputComponent } from '../../../shared/input/input.component';
import { RowComponent } from '../../../shared/row/row.component';
import { InformationBlockComponent } from '../../../shared/information-block/information-block.component';

@Component({
  selector: 'app-hero-report-modal',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    DialogModule,
    ButtonModule,
    InputComponent,
    RowComponent,
    InformationBlockComponent
  ],
  templateUrl: './hero-report-modal.component.html',
  styleUrls: ['./hero-report-modal.component.scss']
})
export class HeroReportModalComponent {
  @Output() save = new EventEmitter<{ coordinates: string, lat: number, lng: number, reportType: 'UXO' | 'SRE' }>();
  visible = false;
  heroReportForm: FormGroup;
  coordinatesError: string | null = null;

  constructor(private fb: FormBuilder) {
    this.heroReportForm = this.fb.group({
      coordinates: [null, Validators.required]
    });
  }

  show() {
    this.heroReportForm.reset();
    this.coordinatesError = null;
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  onSubmit(reportType: 'UXO' | 'SRE' = 'UXO') {
    if (this.heroReportForm.invalid) {
      this.heroReportForm.markAllAsTouched();
      return;
    }
    const coords = this.heroReportForm.value.coordinates.trim();
    const match = coords.match(/^\s*(-?\d{1,3}(?:\.\d+)?)[,\s]+(-?\d{1,3}(?:\.\d+)?)\s*$/);
    const control = this.heroReportForm.get('coordinates');
    if (!match) {
      control?.setErrors({ format: $localize`:@@heroReportModal.coordFormatError:Coordinates must be in the format: 40.375260, -80.210356` });
      control?.markAsTouched();
      return;
    }
    const lat = parseFloat(match[1]);
    const lng = parseFloat(match[2]);
    if (isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180) {
    control?.setErrors({ range: $localize`:@@heroReportModal.coordRangeError:Latitude must be between -90 and 90, longitude between -180 and 180.` });
      control?.markAsTouched();
      return;
    }
    control?.setErrors(null); // clear errors
    this.save.emit({ coordinates: coords, lat, lng, reportType });
    this.hide();
  }

  onCancel() {
    this.hide();
  }
}
